import script from "./TheAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAgreement.vue?vue&type=script&setup=true&lang=js"

import "./TheAgreement.vue?vue&type=style&index=0&id=6ff64fe0&scoped=true&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff64fe0"]])

export default __exports__